var _a;
export var EAccountType;
(function (EAccountType) {
    EAccountType[EAccountType["Shop"] = 1] = "Shop";
    EAccountType[EAccountType["Company"] = 2] = "Company";
    EAccountType[EAccountType["Finance"] = 3] = "Finance";
    EAccountType[EAccountType["ManyShop"] = 4] = "ManyShop";
    EAccountType[EAccountType["Customer"] = 10] = "Customer";
})(EAccountType || (EAccountType = {}));
export default EAccountType;
export var AccountTypeDict = (_a = {},
    _a[EAccountType.Shop] = "门店",
    _a[EAccountType.Company] = "结算公司",
    _a[EAccountType.Finance] = "财税主体",
    _a[EAccountType.ManyShop] = "整体多门店对账模式",
    _a[EAccountType.Customer] = "客户",
    _a);
